const SALESFORCE_OAUTH_CALLBACK_PATH = /^\/salesforce\/(?:(?:production|sandbox)\/)?oauth\/callback\/?$/

/**
 * Whether the URL is the return from Auth0's login page. Salesforce OAuth
 * callbacks also carry `code` and `state`, but belong to the Salesforce flow.
 *
 * @param {{ pathname: string, search: string }} location
 *
 * @returns {boolean}
 */
export const isAuth0RedirectCallback = ({ pathname, search }) => (
  search.includes('code=')
  && search.includes('state=')
  && !SALESFORCE_OAUTH_CALLBACK_PATH.test(pathname)
)

export default isAuth0RedirectCallback
